<!-- SIDEBAR -->
<div [ngClass]="{ sidebar: true }">
  <!-- (mouseover)/(mouseleave) removidos: handlers vazios, mas cada mouseover que borbulhava
       de qualquer filho disparava um ciclo de change detection — tempestade de eventos no hover. -->
  <div class="main-menu">
    @for (module of modules; track module; let isLast = $last) {
      <ng-container>
        <!-- MÓDULO PRINCIPAL -->
        <a (click)="onModuleMouseEnter(module, $event)" (mouseenter)="onModuleMouseEnter(module, $event)" class="menu-item" [ngClass]="{
              active: isActive(module) || hoveredModule === module, 'setting': isLast, 'quick-add': module.isQuickAdd
            }">
          <div [ngClass]="{
                flexbox: true,
                'selected-icon': isActive(module)
              }">
            <mat-icon class="menu-icon">
              {{ module.googleIcone }}
            </mat-icon>
            <div [ngClass]="{
                  'text-collapsed': true,
                  'selected-icon': isActive(module)
                }">
              {{ module.nomePerfil }}
            </div>
          </div>
        </a>
      </ng-container>
    }
  </div>

  <!-- SUBMENUS FLUTUANTES À DIREITA -->
  @if (hoveredModule && hoveredModule.submodules?.length > 0) {
    <!-- Ponte de hover invisível: cobre o vão entre a sidebar e o painel destacado
         para o mouse não "sair" do componente e fechar o submenu na travessia. -->
    <div class="submenu-bridge" [ngStyle]="submenuAnchorBottom
        ? { bottom: submenuBottom + 'px', left: (submenuLeft - 14) + 'px' }
        : { top: submenuTop + 'px', left: (submenuLeft - 14) + 'px' }"></div>
    <div class="submenu-panel" [ngStyle]="submenuAnchorBottom
        ? { bottom: submenuBottom + 'px', left: submenuLeft + 'px' }
        : { top: submenuTop + 'px', left: submenuLeft + 'px' }">
      <div class="submenu-title">
        <span class="submenu-title-text">{{ hoveredModule.nomePerfil }}</span>
      </div>
      @for (submodule of hoveredModule.submodules; track submodule) {
      <a (click)="onSubCardClick(submodule)" class="submenu-item" [ngClass]="{
          active: isActiveSub(submodule),
          selected: isActiveSub(submodule)
        }">
          <div class="submenu-content">
            @if (hoveredModule.isQuickAdd) {
              <mat-icon class="menu-icon">add</mat-icon>
            }
            <mat-icon class="menu-icon">{{ submodule.iconeSubperfil }}</mat-icon>
            <span>{{ submodule.nomeSubPerfil }}</span>
          </div>
        </a>
      }
    </div>
  }
</div>
<div class="mobile-bar">
  <div class="icons-bar">
    <a class="item-bar" (click)="goHome()" [ngClass]="{ selected: isHome() && !isMobileMenuOpen && !isPlusOpen }">
      <mat-icon class="nav-icon">home</mat-icon>
    </a>
    <a class="item-bar" (click)="isPlusOpen = !isPlusOpen; isMobileMenuOpen = false" [ngClass]="{ selected: isPlusOpen && !isMobileMenuOpen }">
      <mat-icon class="nav-icon">add</mat-icon>
    </a>
    @if (!isAdminContext) {
      <a class="item-bar ai-btn" (click)="openAiChat()">
        <mat-icon class="nav-icon">auto_awesome</mat-icon>
      </a>
    }
    <a class="item-bar" (click)="isMobileMenuOpen = !isMobileMenuOpen; isPlusOpen = false" [ngClass]="{ selected: isMobileMenuOpen && !isPlusOpen }">
      <mat-icon class="nav-icon">menu</mat-icon>
    </a>
  </div>
</div>

@if (isMobileMenuOpen) {
  <div class="mobile-overlay" @slideFromRight>
    <div class="mobile-nav">
      <div class="mobile-menu">
        @for (module of modules; track module; let isLast = $last) {
          @if (!module.isQuickAdd) {
          <div class="menu-item">
            <div class="mobile-menu-content">
              <mat-icon class="menu-icon">
                {{ module.googleIcone }}
              </mat-icon>
              <div>
                {{ module.nomePerfil }}
              </div>
            </div>
          </div>
          <ng-container>
            @for (submodule of module.submodules; track submodule) {
              <a (click)="onSubCardClick(submodule); isMobileMenuOpen = false" class="submenu-item">
                <div class="mobile-menu-content">
                  <mat-icon class="menu-icon">{{ submodule.iconeSubperfil }}</mat-icon>
                  <span>{{ submodule.nomeSubPerfil }}</span>
                </div>
              </a>
            }
          </ng-container>
          }
        }
      </div>
    </div>
  </div>
}

@if (isPlusOpen) {
  <div class="mobile-overlay" @slideFromBottom>
    <div class="plus-wrapper">
      @if (isAdminContext) {
        <div class="buttons-wrapper">
          <one-button variant="primary" [full]="true" (clicked)="navigateTo('empresas/novo')">NOVA EMPRESA</one-button>
          <one-button variant="primary" [full]="true" (clicked)="navigateTo('configs/usuarios-admin/novo')">NOVO USUÁRIO ADMIN</one-button>
          <one-button variant="primary" [full]="true" (clicked)="navigateTo('empresas/usuarios-erp/novo')">NOVO USUÁRIO ERP</one-button>
          <one-button variant="primary" [full]="true" (clicked)="navigateTo('dev/workers/novo')">NOVO WORKER</one-button>
          <one-button variant="primary" [full]="true" (clicked)="navigateTo('configs/planos/novo')">NOVO PLANO</one-button>
        </div>
      }
      @if (!isAdminContext) {
        @if (plusMode === '') {
        <div class="buttons-wrapper">
          <one-button variant="primary" [full]="true" (clicked)="navigateTo('venda/pedidos/novo')">NOVO PEDIDO</one-button>
          <one-button variant="primary" [full]="true" (clicked)="navigateTo('estoque/produtos/novo')">NOVO PRODUTO</one-button>
          <one-button variant="secondary" [full]="true" (clicked)="plusMode = 'financeiro'">FINANCEIRO</one-button>
          <one-button variant="secondary" [full]="true" (clicked)="plusMode = 'fiscal'">FISCAL</one-button>
          <one-button variant="secondary" [full]="true" (clicked)="plusMode = 'cadastro'">CADASTROS</one-button>
        </div>
      }
      @if (plusMode === 'financeiro') {
        <div class="buttons-wrapper">
          <one-button variant="primary" [full]="true" (clicked)="navigateTo('financeiro/contas-pagar/novo')">NOVA CONTA A PAGAR</one-button>
          <one-button variant="primary" [full]="true" (clicked)="navigateTo('financeiro/contas-receber/novo')">NOVA CONTA A RECEBER</one-button>
          <one-button variant="primary" [full]="true" (clicked)="navigateTo('financeiro/bancos/novo')">NOVA CONTA BANCÁRIA</one-button>
          <one-button variant="secondary" [full]="true" (clicked)="plusMode = ''">VOLTAR</one-button>
        </div>
      }
      @if (plusMode === 'fiscal') {
        <div class="buttons-wrapper">
          <one-button variant="primary" [full]="true" (clicked)="navigateTo('fiscal/perfil-imposto/novo')">NOVO PERFIL DE IMPOSTO</one-button>
          <one-button variant="primary" [full]="true" (clicked)="navigateTo('fiscal/perfil-pis-cofins/novo')">NOVO PERFIL PIS COFINS</one-button>
          <one-button variant="primary" [full]="true" (clicked)="navigateTo('fiscal/perfil-cest/novo')">NOVO IMPOSTO CEST</one-button>
          <one-button variant="primary" [full]="true" (clicked)="navigateTo('fiscal/mensagem-tributaria/novo')">NOVA MSG. TRIBUTÁRIA</one-button>
          <one-button variant="secondary" [full]="true" (clicked)="plusMode = ''">VOLTAR</one-button>
        </div>
      }
      @if (plusMode === 'cadastro') {
        <div class="buttons-wrapper">
          <one-button variant="primary" [full]="true" (clicked)="navigateTo('cadastro/clientes/novo')">NOVO CLIENTE</one-button>
          <one-button variant="primary" [full]="true" (clicked)="navigateTo('cadastro/fornecedores/novo')">NOVO FORNECEDOR</one-button>
          <one-button variant="primary" [full]="true" (clicked)="navigateTo('cadastro/transportadoras/novo')">NOVA TRANSPORTADORA</one-button>
          <one-button variant="secondary" [full]="true" (clicked)="plusMode = ''">VOLTAR</one-button>
        </div>
      }
      }
    </div>
  </div>
}